/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trackyourbusinessperformancecustomerreviewsandengagementmetrics8Inputs */

const en_trackyourbusinessperformancecustomerreviewsandengagementmetrics8 = /** @type {(inputs: Trackyourbusinessperformancecustomerreviewsandengagementmetrics8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track your business performance, customer reviews, and engagement metrics`)
};

const de_trackyourbusinessperformancecustomerreviewsandengagementmetrics8 = /** @type {(inputs: Trackyourbusinessperformancecustomerreviewsandengagementmetrics8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behalte im Blick, wie oft deine Orte und Events gesehen und geöffnet werden.`)
};

/**
* | output |
* | --- |
* | "Track your business performance, customer reviews, and engagement metrics" |
*
* @param {Trackyourbusinessperformancecustomerreviewsandengagementmetrics8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const trackyourbusinessperformancecustomerreviewsandengagementmetrics8 = /** @type {((inputs?: Trackyourbusinessperformancecustomerreviewsandengagementmetrics8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trackyourbusinessperformancecustomerreviewsandengagementmetrics8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trackyourbusinessperformancecustomerreviewsandengagementmetrics8(inputs)
	return de_trackyourbusinessperformancecustomerreviewsandengagementmetrics8(inputs)
});
export { trackyourbusinessperformancecustomerreviewsandengagementmetrics8 as "trackYourBusinessPerformanceCustomerReviewsAndEngagementMetrics" }